import { useState } from "react";
import { categories } from "@/mocks/gossipData";

const newsPool: Record<string, { title: string; meta: string; color: string }[]> = {
  ent: [
    { title: "顶流小花新剧官宣搭档，阵容引期待", meta: "片方 10 分钟前官宣", color: "bg-primary-500" },
    { title: "男演员深夜发文回应热议，语气引猜测", meta: "平台讨论量上升", color: "bg-accent-400" },
    { title: "某剧组路透流出，服化道获网友好评", meta: "路透视频热传", color: "bg-secondary-400" },
  ],
  tv: [
    { title: "收官综艺冠军揭晓，收视创本季新高", meta: "收视数据公布", color: "bg-accent-400" },
    { title: "新剧开播首周口碑出炉，评分持续走高", meta: "首周数据盘点", color: "bg-primary-500" },
  ],
  music: [
    { title: "新专辑主打音源试听释出，风格获赞", meta: "音源平台热播", color: "bg-secondary-400" },
    { title: "演唱会官宣加场，票务平台即将开抢", meta: "官宣公告", color: "bg-accent-400" },
  ],
  society: [
    { title: "晚高峰暖心一幕刷屏，路人接力帮忙", meta: "现场视频热传", color: "bg-primary-500" },
    { title: "城市避暑新去处走红，本地人直呼宝藏", meta: "本地话题升温", color: "bg-secondary-400" },
  ],
  life: [
    { title: "高校毕业创意照出圈，网友求同款机位", meta: "校园话题发酵", color: "bg-accent-400" },
    { title: "夏日快手菜食谱走红，懒人友好", meta: "美食博主热推", color: "bg-secondary-400" },
  ],
  sports: [
    { title: "热门手游新版本上线，新角色成焦点", meta: "版本更新公告", color: "bg-primary-500" },
    { title: "冠军选手直播互动，粉丝弹幕刷屏", meta: "直播热度飙升", color: "bg-accent-400" },
  ],
};

export default function Columns() {
  const [active, setActive] = useState("ent");
  const news = newsPool[active] ?? [];

  return (
    <section id="columns" className="bg-background-100 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-8 md:mb-10">
          <div>
            <span className="inline-flex items-center gap-1.5 text-sm font-semibold text-primary-600">
              <i className="ri-apps-2-fill text-primary-600"></i>
              栏目分类
            </span>
            <h2 className="mt-2 font-display text-3xl md:text-4xl text-foreground-950">
              想先看哪块瓜田？
            </h2>
            <p className="mt-3 max-w-2xl text-sm md:text-base text-foreground-600 leading-relaxed">
              按栏目切换，娱乐八卦、影视综艺、社会热点……定位你关心的领域，只看想看的瓜。
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
          <div className="lg:col-span-4">
            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-1 gap-3">
              {categories.map((cat) => (
                <button
                  key={cat.key}
                  onClick={() => setActive(cat.key)}
                  className={`flex items-center gap-3 rounded-xl px-4 py-4 text-left transition-all ${active === cat.key ? "bg-primary-500 text-background-50 shadow-soft" : "bg-background-50 text-foreground-800 ring-1 ring-background-200 hover:ring-primary-300 hover:bg-primary-50"}`}
                >
                  <span className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-lg ${active === cat.key ? "bg-background-50/20 text-background-50" : "bg-primary-100 text-primary-700"}`}>
                    <i className={`${cat.icon} text-lg`}></i>
                  </span>
                  <span className="min-w-0">
                    <span className="block text-sm font-semibold whitespace-nowrap">{cat.name}</span>
                    <span className={`block text-xs mt-0.5 ${active === cat.key ? "text-background-100/80" : "text-foreground-500"}`}>{cat.count}</span>
                  </span>
                </button>
              ))}
            </div>
          </div>

          <div className="lg:col-span-8">
            <div className="rounded-2xl bg-background-50 ring-1 ring-background-200 p-5 md:p-8">
              <div className="flex items-center justify-between mb-5">
                <h3 className="text-lg font-bold text-foreground-950">
                  {categories.find((c) => c.key === active)?.name}
                  <span className="ml-2 text-sm font-normal text-foreground-500">最新动态</span>
                </h3>
                <span className="inline-flex items-center gap-1.5 rounded-full bg-accent-100 px-3 py-1 text-xs font-semibold text-accent-800">
                  <span className="relative flex h-1.5 w-1.5">
                    <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-accent-500 opacity-75"></span>
                    <span className="relative inline-flex h-1.5 w-1.5 rounded-full bg-accent-500"></span>
                  </span>
                  持续更新中
                </span>
              </div>
              <ul className="space-y-3">
                {news.map((n, i) => (
                  <li
                    key={i}
                    className="group flex items-center gap-3 rounded-xl bg-background-100/60 px-4 py-3.5 cursor-pointer hover:bg-primary-50 transition-colors"
                  >
                    <span className={`h-2.5 w-2.5 shrink-0 rounded-full ${n.color}`}></span>
                    <div className="min-w-0 flex-1">
                      <p className="truncate text-sm font-medium text-foreground-900 group-hover:text-primary-700 transition-colors">{n.title}</p>
                      <span className="mt-0.5 block text-xs text-foreground-500">{n.meta}</span>
                    </div>
                    <i className="ri-arrow-right-line text-foreground-300 group-hover:text-primary-500 transition-colors shrink-0"></i>
                  </li>
                ))}
              </ul>
              <p className="mt-5 text-center text-xs text-foreground-500">
                栏目内容持续由吃瓜精选热门榜数据驱动生成，实时反映当前栏目讨论焦点。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}